import orderApi from '@/api/order'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  id: 0,
  orderDate: '',
  source: '',
  orderType: '',
  restaurant: '',

  guestName: null,
  phoneNumber: '',
  comment: null,
  cookAt: null,
  address: null,

  paymentMethod: '',
  paymentType: null,
  sum: 0,
  changeFrom: null,
  isPaid: false,
  paidAmount: null,
  paidAt: null,

  deliveryOrderId: '',
  isCreatedInDelivery: false,
  deliveryError: '',

  deliveryRestaurantName: null,
  courierId: null,
  courierName: null,

  deliveryStatus: null,
  deliveryStatusName: null,
  statusChangedAt: null,
  state: null,
  stateName: null,

  dishes: [],

  liveDeliveryStatus: null,
  liveDeliveryStatusLoading: false,

  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetchById({ commit }, id) {
    commit('FORM_RESET')

    return orderApi.getById(id)
      .then(({ data }) => commit('ORDER_FETCHED', data))
      .catch(error => {
        commit('ORDER_FETCH_FAILED', error.response.data)
        throw error
      })
  },
  async fetchLiveDeliveryStatus({ commit }, id) {
    commit('LIVE_DELIVERY_STATUS_LOADING')
    try {
      const { data } = await orderApi.getDeliveryStatus(id)
      commit('LIVE_DELIVERY_STATUS_FETCHED', data)
    } catch {
      commit('LIVE_DELIVERY_STATUS_FETCHED', { isAvailable: false, error: 'Не удалось спросить Delivery' })
    }
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  ORDER_FETCHED(state, data) {
    Object.assign(state, data)
  },
  ORDER_FETCH_FAILED() {
    store.dispatch('message/error', 'PUSH_NOTIFICATION.failedFetch')
  },
  LIVE_DELIVERY_STATUS_LOADING(state) {
    state.liveDeliveryStatusLoading = true
  },
  LIVE_DELIVERY_STATUS_FETCHED(state, data) {
    state.liveDeliveryStatus = data
    state.liveDeliveryStatusLoading = false
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
